import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    tasks: [],
    totalCount: 0,
    activeTab: '',
    pagination: {
      page: 1,
      size: 25
    }
  },
  getters: {
    taskList: state =>
      state.tasks.map(item => ({
        ...item
      }))
  },
  mutations: {
    setTasks(state, payload) {
      state.tasks = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    }
  },
  actions: {
    getTasks({ commit }, query) {
      api.getTasks(query).then(({ data }) => {
        commit('setTasks', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    }
    // createTask(context, data) {
    //   return api.createTask(data);
    // },
    // updateTask(context, data) {
    //   return api.updateTask(data);
    // }
  }
};

appStore.registerModule('task', store);
